const GA_MEASUREMENT_ID = 'G-B0YX341R7Z';

export function trackPageView(path: string, title: string) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: path,
    page_title: title,
    send_to: GA_MEASUREMENT_ID,
  });
}
